import { APIUrlConstants, AppConstants } from "../../../common/APIConstants";
import RestEndPoint from "../../../common/RestEndPoint";

export default class GainLossUnitPriceAPI {
  static getUnitPriceData() {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.GetUnitPrice,
      "GET",
      AppConstants.APP_BACKEND_HOST_KEY
    );
  }

  static saveUnitPriceData(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.SaveUnitPrice,
      "POST",
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }
}
